export const NON_MINI_TMBM_COUNTRIES = [
    'CHN',
    'HKG',
    'MAC',
    'VNM',
]
